import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { MdClose } from 'react-icons/md'

function HistoryBox({ setToggleHistory, dialogRef, historyData }) {
    const toggleOpenHistoryDialog = () => {
        setToggleHistory((prev) => !prev)
    }


    return (
        <Dialog onClose={toggleOpenHistoryDialog}>
            <div ref={dialogRef} className='dialog-api-div'>
                <div className='dialog-api-header'>
                    <h2>Comments History</h2>
                </div>
                <button className="close-icon" onClick={toggleOpenHistoryDialog}>
                    <MdClose size={22} />
                </button>

                <div className='dialog-api-table'>
                    <Grid
                        data={historyData}
                        style={{ maxHeight: '400px' }}
                    >
                        <GridColumn
                            field="Comment"
                            width="300px"
                            title="Comment"
                        />
                        <GridColumn width="250px" field="Created" title="Created" />
                    </Grid>
                </div>
                <DialogActionsBar>

                </DialogActionsBar>
            </div>
        </Dialog>
    )
}

export default HistoryBox